import { useQuery } from "react-query";
import { DashboardEncomenda, ListarEncomendaQuery } from "../typings";
import http from "infra/http";

export function useDashboardEncomenda(query: ListarEncomendaQuery) {
  return useQuery(
    [
      `/v1/encomenda/dashboard`,
      query.mes,
      query.pessoaId,
      query.unidadeId,
      query.dataInicio,
      query.dataFim,
      query.search,
    ],
    async () => {
      const { data } = await http.get<DashboardEncomenda>(
        "/v1/encomenda/dashboard",
        { params: query }
      );
      return data;
    }
  );
}
